import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M21 17.998v-.5l-8.13 -14.99a1 1 0 0 0 -1.74 0l-8.13 14.989v.5c0 1.659 4.03 3.003 9 3.003s9 -1.344 9 -3.002","key":"svg-0"}]]

/**
 * IconCone
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY29uZSIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMjEgMTcuOTk4di0uNWwtOC4xMyAtMTQuOTlhMSAxIDAgMCAwIC0xLjc0IDBsLTguMTMgMTQuOTg5di41YzAgMS42NTkgNC4wMyAzLjAwMyA5IDMuMDAzczkgLTEuMzQ0IDkgLTMuMDAyIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/cone
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCone = createReactComponent('outline', 'cone', 'Cone', __iconNode);

export default IconCone;